import {Component, Input, OnInit} from '@angular/core';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Router} from '@angular/router';

@Component({
  templateUrl: './navigation.html',
  selector: 'header-navigation'
})

export class NavigationComponent implements OnInit {
  navLinks = [];
  @Input() links: string;
  public routes = [];

  constructor(public auth: AuthenticationService, private router: Router) {
    if (this.auth.userRole() === 'admin' || this.auth.userRole() === 'client' || this.auth.userRole() === 'employee') {
      this.routes.push({path: '/dashboard', src: 'assets/img/icon_dashboard.svg', label: 'Dashboard'});

      if (this.auth.isPro() && this.auth.isPremium()) {
        this.routes.push({path: '/alarms', src: 'assets/img/icon_alarms_tasks.svg', label: 'All alarms / tasks'});
        this.routes.push({path: '/reports', src: 'assets/img/icon_reports.svg', label: 'Reports'});
      }
    }

    if (this.auth.userRole() === 'admin') {
      this.routes.push({path: '/admins', src: 'assets/img/icon_clients.svg', label: 'User/ctrl management'});
    }

    if (this.auth.userRole() === 'manufacturer') {
      this.routes.push({path: '/clients', src: 'assets/img/icon_clients.svg', label: 'User/ctrl management'});
    }

    if (this.auth.userRole() === 'client') {
      this.routes.push({path: '/employees', src: 'assets/img/icon_clients.svg', label: 'User management'});
    }

    this.routes.push({path: '/level-of-access', src: 'assets/img/icon_access.png', label: 'Level of access'});
  }

  ngOnInit() {
    this.buildLinks(this.auth.userRole());
  }

  private buildLinks(role: string) {
    switch (this.links) {
      case 'admins':
      case 'manufacturers':
      case 'clients':
      case 'employees':
      case 'controller':
      case 'controllers':
        if (role === 'admin') {
          this.navLinks.push({path: '/admins', label: 'Vortex Admins'});
          this.navLinks.push({path: '/manufacturers', label: 'Vortex Manufacturers'});
        }

        if (role === 'admin' || role === 'manufacturer') {
          this.navLinks.push({path: '/clients', label: 'Clients'});
        }

        if (role === 'admin' || role === 'client') {
          this.navLinks.push({path: '/employees', label: 'Users'});
        }

        if (role === 'admin' || role === 'manufacturer') {
          this.navLinks.push({path: '/controllers', label: 'Controllers'});
        }

        break;
      case 'alarms':
      case 'profile':
      case 'dashboard':
      case 'level-of-access':
        break;
      case 'reports':
        this.navLinks = [
          {path: '/reports/crowd', label: 'Site Usage'},
          {path: '/reports/conso', label: 'Conso'},
          {path: '/reports/alarms', label: 'Alarms'},
          {path: '/reports/hardware', label: 'Hardware'},
          {path: '/reports/custom', label: 'Custom'},
          {path: '/reports/map', label: 'Map'},
        ];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/navigation/navigation.component.ts